/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventoTipoPratica } from './evento-tipo-pratica';
import { TipoPraticaCanaleComunicazioneDTO } from './tipo-pratica-canale-comunicazione-dto';


export interface TipoPraticaEventoComunicazioneDTO { 
    id?: string;
    tipo_pratica_id?: string;
    evento?: EventoTipoPratica;
    canali?: Array<TipoPraticaCanaleComunicazioneDTO>;
    version?: number;
    created_at?: string;
    updated_at?: string;
}



